module.exports = __webpack_public_path__ + "static/img/publicWX_de.197d944.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/publicWX_de.jpg
// module id = zgw1
// module chunks = 89